"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATE = void 0;
const tab_1 = require("../../../tab");
exports.DATE = {
    description: 'parse date value from year, month and day parameters',
    arg_names: ['year', 'month', 'day'],
    args_def: [
        {
            types: ['number', 'string', 'int'],
            required: true,
        },
        {
            types: ['number', 'string', 'int'],
            required: true,
        },
        {
            types: ['number', 'string', 'int'],
            required: true,
        },
    ],
    args_description: ['date`s year', 'date`s month', 'date`s day'],
    return_type: tab_1.ColumnType.DATE,
};
